export type {
	Props as MultiUserPickerProps,
	MultiUserPickerOption,
} from './multi-user-picker-dumb';
export { default as MultiUserPickerDumb } from './multi-user-picker-dumb';
